// extracted by mini-css-extract-plugin
export default {"addToCartControl":"y2-z","giftCard":"z2-z","btnContainer":"A2-z","cartButton":"B2-z","disabled":"C2-z"};